import * as _ from 'lodash';
import { MaxOrderQuantity, TicketFeeType } from '../consts/Checkout';

const isVisibleTicket = (ticket, theEvent) => {
  if (!ticket.ignore_active && !ticket.is_active) {
    return false;
  }
  if (ticket.is_need_code_to_show) { //  && !this.is_reveal_ticket()
    return false;
  }
  const begin_time_utc = _.get(ticket, 'sale_begin_time_utc', '2016-01-01T00:00:00Z');
  const end_time_utc = _.get(ticket, 'sale_end_time_utc', _.get(theEvent, 'schedules[0].end_time_utc', Date.now())); // _.get(theEvent, 'schedules[0].end_time_utc', Date.now()); //
  const now = new Date(Date.now()).getTime(); // this.buyServices.utcNow()
  const btime = new Date(begin_time_utc).getTime();
  const etime = new Date(end_time_utc).getTime();

  if (btime - now > 0 && ticket.is_set_sale_time) {
   return false;
  }

  if (now - etime > 0 && ticket.is_set_sale_time) {
    return false;
  }

  return true;
};

export const _visibleTickets = (theEvent, tickets, filterId = '') => {
  return _.filter(tickets, (t: any) => {
    if (filterId !== '') {
      return isVisibleTicket(t, theEvent) && t.id.toString() === filterId.toString();
    }

    if (isVisibleTicket(t, theEvent)) {
      return t;
    }

    // return t.isVisible;
  });
};

export const _hiddenTickets = (tickets: any): any => {
  return _.filter(tickets, (t: any): any => (t.is_need_code_to_show));
};

export const _visibleDonations = (donations: any): any => {
  return _.filter(donations, (d: any): any => d.is_active);
};

export const getRemainQuantity = (theEvent, include_selected_quantity = false, _ticket, buyCart = []) => {
  // var theEvent = this.buyServices.theEvent;
  const stock_quantity = _.get(_ticket, 'stock_quantity', 0);

  if (theEvent.is_set_tickets_total_capacity) {
    // Count the tickets sold
    let sold_quantity = 0;

    for (const ticket of theEvent.tickets) {
      const temp = _ticket;

      sold_quantity += _.get(temp, 'stock_quantity', 0) - _.get(_ticket, 'current_inventory.stock_quantity', 0);
      
      // Whether to include the number of votes selected by the current ticket category
      if (include_selected_quantity && _.toString(ticket.id) !== _.toString(_ticket.id)) {
        const dddd = _.filter(buyCart, i => i.id !== ticket.id);
        sold_quantity += _.size(dddd); // ticket.count;
      }
    }

    // Get total votes
    let total_quantity = theEvent.tickets_total_capacity - sold_quantity;

    if (total_quantity < 0) {
      total_quantity = 0;
    }
  
    // console.log('in return', total_quantity, stock_quantity)

    return Math.min(total_quantity, stock_quantity);
  }

  return stock_quantity;
};

export const canAdd = (theEvent, ticket, VT, buyCart) => {
  return getAddCount(false, theEvent, ticket, VT, buyCart);
};

export const canRemove = (props, ticketId?) => {
  const minQuantity = getTicketMinMaxCountity(props, ticketId).min
  const currentCount = count(props, ticketId)
  return currentCount > minQuantity;
};

export const count = (props, ticketId?) => {
  if (ticketId) {
    return _.filter(props.buyCart, (ticket: any) => ticket.id.toString() === ticketId.toString()).length;
  }

  return _.size(props.buyCart);
};
const getTicketMinMaxCountity = (props, ticketId?) => {
  const ticket = _.find(props.eventDetail.tickets, (ticket: any) => ticket.id.toString() === ticketId.toString());
  return {
    min: ticket.order_min_quantity,
    max: ticket.order_max_quantity
  }
}

const getSelectedQuantity = (ticket, VT) => {
  // var ticket = this.ticket;
  let other_quantity = 0;

  for (const other_ticket of VT) {
    // if (other_ticket.id != ticket.id) {
    other_quantity += 1; // other_ticket.count();
    // }
  }
  return other_quantity;
};

/**
 * Add ticket to shopping cart
 */
export const add = (theEvent, ticket, VT, cb, buyCart) => {
  const add_count = getAddCount(false, theEvent, ticket, VT, buyCart);

  if (add_count > 0) {
    // this.buyServices.buyCart.addTicket(this.ticket, add_count);
    return cb(add_count, ticket);
  }
};

/**
 * Remove from shopping cart
 */
export const remove = (props, cb) => {
  if (count(props, props.ticket.id) > 0) {
    let del_count = 1;

    if (count(props, props.ticket.id) === props.ticket.order_min_quantity) {
      del_count = count(props, props.ticket.id);
    }

    return cb(del_count, props.ticket);

    // this.buyServices.buyCart.removeTicket(this.ticket.id, del_count);
  }
};

export const getAddCount = (trigger = true, theEvent, ticket, VT, buyCart) => {
  // The remaining votes of the currently selected ticket category
  const remain_quantity = getRemainQuantity(theEvent, true, ticket, buyCart);
  
  // Total number of votes currently selected
  const selected_quantity = getSelectedQuantity(ticket, VT);
  // Is the number of remaining votes 0
  if (!remain_quantity) {
    return 0;
  }

  let add_count = 1;

  // If the number of tickets currently selected is 0;
  if (count({ buyCart }, ticket.id) === 0) {
    // Minimum number of tickets purchased
    add_count = ticket.order_min_quantity || 1;
    // If it is the first time to add a ticket
    if (trigger && this.__is_first_add_ticket) {
      // Get the default number of tickets purchased
      let default_quantity = ticket.default_ticket_quantity || 0;

      // If the number of tickets purchased by default is greater than the remaining tickets
      if (default_quantity > remain_quantity) {
        default_quantity = 0;
      }
      // If the default number of tickets purchased + the total number of votes is greater than 50
      if (default_quantity + selected_quantity > MaxOrderQuantity) {
        default_quantity = 0;
      }
      add_count = default_quantity;
      this.__is_first_add_ticket = false;
    }
  }

  // If the current ticket + the ticket to be added is greater than the remaining tickets
  // of the current ticket category, do not add
  if (count({ buyCart }, ticket.id) + add_count > remain_quantity) {
    // trigger && app.trigger("gt:remain:quantity", ticket);

    return 0;
  }
  // If the current ticket + the ticket to be added is greater than the remaining
  // tickets of the current ticket category, do not add
  if (add_count + selected_quantity > MaxOrderQuantity) {
    // trigger && app.trigger("gt:order:max:quantity", MaxOrderQuantity);

    return 0;
  }

  // console.log('\n\n buyService.js : 655 /--------------------------------');
  // console.log(count({ buyCart }, ticket.id), ticket.order_max_quantity);
  // console.log('buyService.js : 655 --------------------------------/\n\n');

  // If the current number of tickets + the number of tickets to be added is greater
  // than the maximum number of tickets purchased, do not add
  if ((count({ buyCart }, ticket.id) + add_count) > ticket.order_max_quantity) {
    // trigger && app.trigger("gt:ticket:max:quantity", ticket);

    return 0;
  }

  return add_count;
};

export const leftTime = (tickets) => {
  const now = new Date(Date.now()).getTime();
  const not_begin_tickets = _.filter(tickets, (t: any) => new Date(t.sale_begin_time_utc).getTime() > now);
  const first_begin_date: any = _.min([not_begin_tickets, (m) => new Date(m.sale_begin_time_utc).getTime()]);

  return first_begin_date - now;
};

// -1: not started, 0: normal ticket sales, 1: finished ticket sales, null loading
export const ticketsState = (tickets, donations, theEvent) => {
  let state = 1;

  if (tickets.length === 0 && donations.length === 0) {
    state = -2;
  }

  if (_visibleDonations(donations).length > 0 || _visibleTickets(theEvent, tickets).length > 0) {
    state = 0;
  } else if (leftTime(tickets) > 0) {
    state = -1;
  }
  // if (this.utcNow() == null) {
  //   state = null;
  // }
  // if (this.reseting()) {
  //   state = null;
  // }
  return state;
};

// Total donation amount
export const donationTotal = (donations) => {
  let sum = 0;

  for (const donation of donations) {
    sum += _.get(donation, 'amount', _.get(donation, 'prefilled_amount', 0)); // (donation.amount || donations.prefilled_amount);
  }

  return sum;
};

export const canCheckout = (buyCart, donations) => {
  const ticketCnt = _.size(buyCart);
  const donationCnt = donationTotal(donations);

  // if (this.reseting()) {
  //   return false;
  // }

  return ticketCnt > 0 || donationCnt > 0;
};

export const fee = (ticket: any): number => {
  let _fee = ticket.merchant_fee;

  if (ticket.fee_type === TicketFeeType.ExcludeFee) {
    _fee = (ticket.merchant_fee +
      ticket.payment_method_additional_fee +
      ticket.payment_method_additional_fix_fee +
      ticket.sparxo_fee);
  }

  return _fee;
};

export const calculator = (numTickets: number, price: number, merchantFee: number): {} => {
  const sparxoFee: any = {};
  const ccFee: any = {};
  const ticketPrice: any = {};
  const totalfee: any = {};
  const ticketRevenue: any = {};
  const feeRevenue: any = {};
  const briteFee: any = {};
  const briteCCFee: any = {};
  const briteCost: any = {};
  const briteTotalTicket: any = {};
  const briteFeeIn: any = {};
  const briteCCFeeIn: any = {};
  const briteTotalTicketIn: any = {};

  // numTickets
  // ticketFee - price
  // merchantFee

  // Calculate Input Fields
  function calSparxoFee() {
    const ticketFee = Number(price); // document.getElementById("ticketFee").value.replace(/[A-Za-z$-]/g, "");

    let fee = 0;

    if (ticketFee > 0 && ticketFee < 25) {
 fee = 1;
}
    if (ticketFee >= 25 && ticketFee < 50) {
 fee = 2;
}
    if (ticketFee >= 50) {
 fee = 3;
}

    sparxoFee.value = fee.toFixed(2);
  }

  function calcCCFee() {
    const _sparxoFee = sparxoFee.value; // document.getElementById("sparxoFee").value.replace(/[A-Za-z$-]/g, "")
    const ticketFee = price; // document.getElementById("ticketFee").value.replace(/[A-Za-z$-]/g, "")
    // let ticketPrice = document.getElementById("ticketPrice").value.replace(/[A-Za-z$-]/g, "")
    // let merchantFee = merchantFee; // document.getElementById("merchantFee").value.replace(/[A-Za-z$-]/g, "")

    const ticket = (Number(ticketFee) + Number(_sparxoFee) + Number(merchantFee) + 0.30) / 0.971;
    // const ticket = 93 / x + 0.30;
    // 0.9618521771865982
    // 0.9561385529821684
    // const ticket = ((Number(ticketFee) + Number(_sparxoFee) + Number(merchantFee)) * 0.029) + 0.3;

    // (Number(ticketFee) + Number(_sparxoFee) + Number(merchantFee) + 0.30)
    // 97.58 = 93.3 / x
    // 159.38 = 153.3 / x

    const _fee = Number(ticket) - Number(_sparxoFee) - Number(ticketFee) - Number(merchantFee);
    // const 4.58 = Number(ticket3) - 3 - 65 - 25;
    // const 6.38 = Number(ticket3) - 3 - 150;

    // console.log('\n\n buyService.js : 311 /--------------------------------');
    // console.log('ticket2', ticket2, ticket2 / 0.971);
    // console.log('_fee', _fee);
    // console.log('buyService.js : 311 --------------------------------/\n\n');

    ccFee.value = _fee.toFixed(2);
  }

  // Sparxo Fee
  function calcSparxo() {
    // let merchantFee = document.getElementById("merchantFee").value.replace(/[A-Za-z$-]/g, "");
    const _sparxoFee = sparxoFee.value; // document.getElementById("sparxoFee").value.replace(/[A-Za-z$-]/g, "");
    const ticketFee = price; // document.getElementById("ticketFee").value.replace(/[A-Za-z$-]/g, "");
    // let numTickets = document.getElementById("numTickets").value.replace(/[A-Za-z$-]/g, "");


const _ccFee = ccFee.value; //  document.getElementById("ccFee").value.replace(/[A-Za-z$-]/g, "");

    const ticket = Number(ticketFee) + Number(_sparxoFee) + Number(merchantFee) + Number(_ccFee);

    const fee = ticket - Number(ticketFee);

    const revenue = Number(ticketFee) * Number(numTickets);

    const yourFee = Number(merchantFee) * Number(numTickets);

    ticketPrice.value = ticket.toFixed(2);
    totalfee.value = fee.toFixed(2);
    ticketRevenue.value = revenue.toFixed(2);
    feeRevenue.value = yourFee.toFixed(2);
  }

  // endsparxo fee
  function eventbriteFee() {
    const ticketFee = document.querySelector<HTMLInputElement>('#ticketFee')!.value.replace(/[A-Za-z$-]/g, '');
    const numTickets = document.querySelector<HTMLInputElement>('#numTickets')!.value.replace(/[A-Za-z$-]/g, '');
    
    // let ticketFee = document.getElementById("ticketFee").value.replace(/[A-Za-z$-]/g, "");

    let math = Number(ticketFee) * 0.025 + 0.99;

    if (math > 19.95) {
      math = 19.95;
    } else {
      math = math;
    }


    const math1 = (Number(ticketFee) * 0.029) + 0.30 + math;

    const math2 = (Number(ticketFee) * 0.029) + 0.30;

    const math3 = ((Number(ticketFee) * 0.029) + 0.30) * Number(numTickets);

    const math4 = math1 + Number(ticketFee);

    briteFee.value = `$${  math1.toFixed(2)}`;
    briteCCFee.value =  `$${  math2.toFixed(2)}`;
    briteCost.value = `$${  math3.toFixed(2)}`;
    briteTotalTicket.value = `$${  math4.toFixed(2)}`;
  }

  function eventbriteFeeIn() {
    const ticketFee = document.querySelector<HTMLInputElement>('#ticketFee')!.value.replace(/[A-Za-z$-]/g, '');
    const numTickets = document.querySelector<HTMLInputElement>('#numTickets')!.value.replace(/[A-Za-z$-]/g, '');

    // let ticketFee = document.getElementById("ticketFee").value.replace(/[A-Za-z$-]/g, "");

    let math = Number(ticketFee) * 0.025 + 0.99;

    if (math > 9.95) {
      math = 9.95;
    } else {
      math = math;
    }

    const math1 = (Number(ticketFee) * 0.03) + math;

    const math2 = (Number(ticketFee) * 0.03);

    const math3 = (Number(ticketFee) * 0.03) * Number(numTickets);

    const math4 = math1 + Number(ticketFee);

    briteFeeIn.value = `$${  math1.toFixed(2)}`;
    briteCCFeeIn.value =  `$${  math2.toFixed(2)}`;
    // briteCostIn.value = "$" + math3.toFixed(2);
    briteTotalTicketIn.value = `$${  math4.toFixed(2)}`;
  }

  function calculateInput() {
    calSparxoFee();
    calcCCFee();
    calcSparxo();
  }

  calculateInput();

  return {
    ticketPrice,
    totalfee,
    ticketRevenue,
    feeRevenue,
    sparxoFee,
    ccFee
  };
};

export const handleStripeErrorMessage = (err: string): string => {
  if (err === 'Stripe: This Connect account cannot currently make live charges. The `requirements.disabled_reason` property on the account will provide information about why this account is currently disabled. If you are a customer trying to make a purchase, please contact the owner of this site. Your transaction has not been processed.'){
    return 'Your transaction has not been processed. Please contact the event producer and ask them to check their payment provide'
  }
  return err;
}



// WEBPACK FOOTER //
// ./src/utils/buyService.ts